// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"CreateEditEquipmentSchedule_titleContainer__3uoU4","assignButton":"CreateEditEquipmentSchedule_assignButton__3bjzv"};